import { Icon, type IconDefinition } from '@vrplatform/icons';
import { Text } from '@mantine/core';
import { Card, Center, rem } from '@mantine/core';

export const OnboardingSelectCard = ({
  icon,
  title,
  onClick,
  description,
  isActive,
}: {
  icon?: IconDefinition;
  onClick: () => void;
  title: string;
  description: string;
  isActive?: boolean;
}) => (
  <Card
    sx={(theme) => ({
      display: 'flex',
      cursor: 'pointer',
      flexWrap: 'nowrap',
      flexDirection: 'column',
      alignItems: 'flex-start',
      transition: 'background-color 0.2s ease',
      boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.06)',
      borderRadius: '0.5rem',
      padding: theme.spacing.lg,
      ':hover': {
        backgroundColor: theme.colors[theme.primaryColor][0] + 50,
      },
      ':focus':
        typeof isActive === 'boolean'
          ? undefined
          : {
              backgroundColor: theme.colors[theme.primaryColor][0] + 50,
              outline: !isActive
                ? `2px solid ${theme.colors[theme.primaryColor][5]}`
                : undefined,
            },
      ...(isActive && {
        backgroundColor: theme.colors[theme.primaryColor][0] + 50,
        outline: `2px solid ${theme.colors[theme.primaryColor][5]}`,
      }),
    })}
    data-testid={title}
    onClick={onClick}
    withBorder
    component="button"
  >
    {icon && (
      <Center mb={'xs'}>
        <Icon
          icon={icon}
          size={24}
          color={(theme) => theme.colors[theme.primaryColor][5]}
        />
      </Center>
    )}
    <Text component="span" fw={500} size="md" ta="left" mb={rem(3)}>
      {title}
    </Text>
    <Text component="span" size="sm" c="gray" ta="left">
      {description}
    </Text>
  </Card>
);
